import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const WizardContentAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "wizard-content" */ './wizard-content'),
  componentName: 'WizardContent',
});
